const CurveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45.063"
    height="45.063"
    viewBox="0 0 45.063 45.063"
  >
    <defs>
      <clipPath id="curve-clip">
        <rect
          id="Rectangle_13"
          data-name="Rectangle 13"
          width="45.063"
          height="45.063"
          fill="#fff"
        />
      </clipPath>
    </defs>
    <g
      id="Group_5"
      data-name="Group 5"
      opacity="0.802"
      style={{ mixBlendMode: 'overlay', isolation: 'isolate' }}
    >
      <g id="Group_4" data-name="Group 4" clipPath="url(#curve-clip)">
        <path
          id="Path_12"
          data-name="Path 12"
          d="M41.178,29.912H29.912A22.517,22.517,0,0,0,52.443,52.443V41.178A11.258,11.258,0,0,1,41.178,29.912"
          transform="translate(-7.381 -7.381)"
          fill="#fff"
        />
        <path
          id="Path_13"
          data-name="Path 13"
          d="M22.531,0H0V22.531H11.266V11.266H22.531A11.3,11.3,0,0,1,33.8,22.531H45.063A22.557,22.557,0,0,0,22.531,0"
          transform="translate(0 0)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);

export default CurveIcon;
